import { Colors } from '@sigma-frontend-libs/commons'
import { TaskStates } from '@sigmasms/shared-types'

import { buttonModes, components, getISODate, icons } from '@/utils'

import button from '@/components/button'

function renderDatePicker(h) {
  let scheduleLabel = this.getTranslate('tasks.actions.start')
  if (this.computedDate) {
    scheduleLabel = this.getTranslate('tasks.actions.schedule')
  }

  return h(
    'div',
    {
      class: 'grid grid-gap--8 pa-2'
    },
    [
      h(
        'g-date-picker',
        {
          props: {
            value: this.changeableDate.date,
            localeTag: this.locale,
            range: false,
            min: new Date().setDate(new Date().getDate() - 1),
            filter: dates => {
              return dates.map(date => {
                return date && getISODate(date)
              })
            }
          },
          on: {
            input: event => {
              this.changeableDate.date = event
            }
          }
        }
      ),

      h(
        components['text-field'],
        {
          props: {
            value: this.changeableDate.time,
            type: 'time',
            dense: true,
            details: false
          },
          on: {
            input: event => {
              this.changeableDate.time = event
            }
          }
        }
      ),

      h(
        'div',
        {
          class: 'fjcfe'
        },
        [
          h(
            button,
            {
              props: {
                label: scheduleLabel,
                loading: this.loading,
                disabled: this.loading,
                color: Colors.success,
                mode: buttonModes.flat
              },
              on: {
                click: () => {
                  this.updateTask(this.value.id, TaskStates.scheduled, this.computedDate)
                }
              }
            }
          )
        ]
      )
    ]
  )
}

export default function(h) {
  if (this.value.state === TaskStates.paused) {
    return h(
      'g-menu',
      {
        props: {
          closeOnContentClick: false,
          placement: 'bottom-end',
          offsetDistance: 8,
          rounded: true
        }
      },
      [
        h(
          button,
          {
            props: {
              mode: buttonModes.flat,
              icon: icons.play_arrow,
              color: Colors.success
            },
            slot: 'activator'
          }
        ),

        renderDatePicker.call(this, h)
      ]
    )
  }

  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: icons.pause,
        color: Colors.secondary,
        disabled: !~[ TaskStates.running, TaskStates.scheduled ].indexOf(this.value.state)
      },
      on: {
        click: () => {
          this.updateTask(this.value.id, TaskStates.paused)
        }
      }
    }
  )
}
